// extracted by mini-css-extract-plugin
module.exports =  {"content":"MsM8S_wlQVyM17V1tPA0","label":"tSHeKSteLSIUFxekhXjl"};